import React from 'react'

import { ReactComponent as LoadingIcon } from '../../assets/icons/loading.svg'
import './Button.css'

export function Button(props) {

    let className = ['btn']
	className.push(`btn-${props.color ?? 'purple'}`) 
	if(props.link ) className.push(`btn-link`) 
    // addtional class names
	if(props.className) className.push(`${props.className}`)  

    // Generate String format : ClassName
	className = className.join(' ')

   

	return (
		<button
           type="button" 
           {...props}
            className={className}
            >
                { props?.loading === true && <span className="loading-icon"><LoadingIcon /></span> }
                {/* <span className="loading-icon"><LoadingIcon /></span> */}
                {props.children}</button>
	)
}